@if (iconToMap()) {
    <app-vvr-icon (iconClick)="onNoClick()" [dark]="false" [full]="false" [overlay]="true" [shadow]="false" link=""></app-vvr-icon>
} @else {
    <app-vvr-icon [dark]="false" [full]="false" [overlay]="true" [shadow]="false"></app-vvr-icon>
}
<div class="topbar">
    <div class="detail-nav">
        <div
            (click)="openSideBarAction($event)"
            class="fab small"
            id="btn-AllParts"
            matTooltip="Toon delen"
            matTooltipPosition="below">
            <i class="fas fa-clipboard-list"></i>
        </div>
        @if (!iconToMap()) {
            <div (click)="onNoClick()" class="fab small" id="btn-BackToMap" matTooltip="Terug naar kaart" matTooltipPosition="below">
                <i [class.fa-list-ul]="backToList()" [class.fa-map]="!backToList()" class="fas"></i>
            </div>
        }
        <div
            (click)="backToPushpinLocation()"
            class="fab small"
            matTooltip="Open locatie op kaart"
            matTooltipPosition="below">
            <i class="fas fa-search-location"></i>
        </div>
        <div
            (click)="openNavi()"
            class="fab small"
            matTooltip="Open navigatie"
            matTooltipPosition="below">
            <i class="fas fa-map-marked"></i>
        </div>
    </div>
    <div class="spacer"></div>
    @if (showDelete() && !activePushpinPart()) {
        <div
            (click)="deletePushpin()"
            [class.disabled]="saving() || activePushpinPart()?.inspection?.lock"
            class="fab big primary"
            id="btn-delete"
            matTooltip="Verwijder punaise"
            matTooltipPosition="before">
            @if (saving()) {
                <i class="fas fa-circle-notch fa-spin"></i>
            } @else {
                <i class="fas fa-trash"></i>
            }
        </div>
    }
    @if (activePushpinPart()) {
        <div class="part-tools">
            <div
                (click)="copy(activePushpinPart)"
                class="fab small"
                id="btn-Copy"
                matTooltip="Kopiëer dit deel"
                matTooltipPosition="below">
                <i class="fas fa-copy"></i>
            </div>
            @if (AuthorisationService.hasFeature('pushpinPartLog') && activePushpinPart()?.id) {
                <div
                    (click)="openPushpinPartLog(activePushpinPart)"
                    class="fab small"
                    id="btn-History"
                    matTooltip="Wijzigingshistorie"
                    matTooltipPosition="below">
                    <i class="fas fa-history"></i>
                </div>
            }
            @if (!activePushpinPart().deleted_at && AuthorisationService.hasFeature('pushpinDeleteAny') || (activePushpinPart().status_id === 8 && userId() === activePushpinPart().user_id)) {
                <div
                    (click)="removePushpinPart(activePushpinPart)"
                    class="fab small primary"
                    id="btn-TrashPart"
                    matTooltip="Verwijder deel"
                    matTooltipPosition="below">
                    <i class="fas fa-trash"></i>
                </div>
            }
            @if (activePushpinPart().deleted_at && AuthorisationService.hasFeature('showDeletedPushpins')) {
                <div
                    (click)="restorePushpinPart(activePushpinPart)"
                    class="fab small primary"
                    id="btn-TrashPartRestore"
                    matTooltip="Verwijderd deel terugzetten"
                    matTooltipPosition="below">
                    <i class="fas fa-trash-restore"></i>
                </div>
            }
        </div>
    }
</div>
@if (openSideBar()) {
    <div (click)="openSideBar.set(false)" class="filter-overlay"></div>
}
@if (pushpin()) {
    <div class="detail">
        <div [class.opened]="openSideBar()" class="detail-sidebar">
            <div class="detail-sidebar-scroller">
                <div (click)="openPushpinPart(null)" [class.active]="!activePushpinPart()" class="part-sidebar curpoint">
                    <div class="part-sidebar-title">
                        <h2 class="h5 condensed">Locatiegegevens</h2>
                    </div>
                    <i class="fas fa-angle-right"></i>
                </div>
                @for (pushpinPart of pushpin().pushpin_parts | filter : inspection?.id : 'inspection_id'; track pushpinPart.id) {
                    <div
                        (click)="openPushpinPart(pushpinPart)"
                        [class.active]="activePushpinPart() == pushpinPart"
                        [class.deleted]="pushpinPart.deleted_at"
                        [class.invalid]="pushpinPart['invalid']"
                        class="part-sidebar curpoint">
                        <i class="fas fa-trash"></i>
                        <div class="part-sidebar-title">
                            <h2 class="h6 condensed">{{pushpinPart.decoration.decoration_group}} @if (pushpinPart.decoration.decoration_group == 'Lengtemarkering' && !pushpin().lengthmark) {
                                <span>(kort)</span>
                            }
                            </h2>
                            <p class="label">
                                {{materialName(pushpinPart.material_id)}}
                                {{pushpinPart.decoration.name}}
                            </p>
                        </div>
                        <i class="fas fa-angle-right"></i>
                    </div>
                }
                @if ((pushpin().pushpin_parts | filter : inspection?.id : 'inspection_id').length < pushpin().pushpin_parts.length && AuthorisationService.hasFeature('changePushpinPartInspection')) {
                    <div class="part-sidebar">
                        <button (click)="showFromOtherInspections.set(!showFromOtherInspections())" mat-button>
                            {{showFromOtherInspections() ? 'Verberg delen uit andere schouwronden' : 'Toon delen uit andere schouwronden'}}
                        </button>
                    </div>
                    @if (showFromOtherInspections()) {
                        @for (pushpinPart of pushpin().pushpin_parts | filter : inspection?.id : 'inspection_id' : true; track pushpinPart.id) {
                            <div
                                (click)="openPushpinPart(pushpinPart)"
                                [class.active]="activePushpinPart() == pushpinPart"
                                [class.deleted]="pushpinPart.deleted_at"
                                [class.invalid]="pushpinPart['invalid']"
                                class="part-sidebar curpoint">
                                <i class="fas fa-trash"></i>
                                <div class="part-sidebar-title">
                                    <h2 class="h6 condensed">{{pushpinPart.decoration.decoration_group}} @if (pushpinPart.decoration.decoration_group == 'Lengtemarkering' && !pushpin().lengthmark) {
                                        <span>(kort)</span>
                                    }
                                    </h2>
                                    <p class="label">
                                        {{materialName(pushpinPart.material_id)}}
                                        {{pushpinPart.decoration.name}}
                                    </p>
                                </div>
                                <i class="fas fa-angle-right"></i>
                            </div>
                        }
                    }
                }
            </div>
            @if (showAddPartButton()) {
                <div class="add-part">
                    <button (click)="createNewPushpinPart()" mat-raised-button>
                        <i class="fas fa-plus"></i>
                        Voeg markeringsitem toe
                    </button>
                </div>
            }
        </div>
        @if (pushpin()) {
            <div class="detail-container">
                <h1 class="h3 condensed">
                    Punaise {{pushpin().number}} {{pushpin().lengthmark ? ' - lengtemarkering' : ''}}
                    {{activePushpinPart()?.deleted_at ? ' (verwijderd)' : ''}}
                </h1>
                @if (pushpin().snappedpoints) {
                    <p>
                        Berekende lengte: {{pushpin().snappedpoints.totalLength | number}}m
                    </p>
                }
                @if (!activePushpinPart()) {
                    <div>
                        <form [formGroup]="form()">
                            <div class="row">
                                <mat-form-field appearance="fill" class="col-md-9">
                                    <mat-label>Straat</mat-label>
                                    <input formControlName="street" id="street" matInput name="street" placeholder="Straatnaam" type="text">
                                    <mat-error>Dit veld mag maximaal 255 tekens bevatten</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="col-md-3">
                                    <mat-label>Huisnummer</mat-label>
                                    <input formControlName="housenumber" id="housenumber" matInput name="housenumber" placeholder="Bijv. 12" type="text">
                                    <mat-error>Dit veld mag maximaal 20 tekens bevatten</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="row">
                                <mat-form-field appearance="fill" class="col-md-2">
                                    <mat-label>Postcode</mat-label>
                                    <input formControlName="zipcode" id="zipcode" matInput name="zipcode" placeholder="Bijv. 1234 AB" type="text">
                                    <mat-error>Dit veld mag maximaal 7 tekens bevatten</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="col-md-6">
                                    <mat-label>Plaats</mat-label>
                                    <input formControlName="place" id="place" matInput name="place" placeholder="Plaatsnaam" type="text">
                                    <mat-error>Dit veld mag maximaal 255 tekens bevatten</mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="col-md-4">
                                    <mat-label>Referentie</mat-label>
                                    <input formControlName="reference" id="reference" matInput name="reference" placeholder="Referenctie" type="text">
                                    <mat-error>Dit veld mag maximaal 255 tekens bevatten</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="row">
                                <mat-form-field appearance="fill" class="col-md-12">
                                    <mat-label>Beschrijving</mat-label>
                                    <textarea
                                        cdkAutosizeMinRows="4"
                                        cdkTextareaAutosize
                                        formControlName="description"
                                        id="description"
                                        matInput
                                        name="description"
                                        placeholder="Voeg hier eventuele notities en opmerkingen toe"
                                        type="text">
                                    </textarea>
                                    <mat-error>Dit veld mag maximaal 16500 tekens bevatten</mat-error>
                                </mat-form-field>
                            </div>
                        </form>
                        @if (showPortraitControls()) {
                            <div>
                                <button (click)="createNewPushpinPart()" class="me-3" mat-raised-button>
                                    <i class="fas fa-plus"></i> Voeg markeringsitem toe
                                </button>
                                <button (click)="openSideBarAction($event)" mat-raised-button>
                                    <i class="fas fa-clipboard-list"></i> Toon delen
                                </button>
                            </div>
                        }
                    </div>
                } @else {
                    <div>
                        <div class="row">
                            <div class="col-12">
                                <app-pushpin-part-detail
                                    #pushpinPartDetail
                                    (addForm)="addForm($event, activePushpinPart())"
                                    (setBackbuttonAction)="setBackbuttonAction()"
                                    (takePicture)="takePicture()"
                                    [customerArea]="customerArea"
                                    [formMap]="forms"
                                    [inspection]="inspection"
                                    [pushpinPart]="activePushpinPart()"
                                    [pushpin]="pushpin()"
                                    [uploadDrag]="dragOver()">
                                </app-pushpin-part-detail>
                            </div>
                        </div>
                    </div>
                }
                @if (!activePushpinPart()) {
                    <div mat-dialog-actions>
                        @if (pushpin().end_lng) {
                            <button [matMenuTriggerFor]="menu" mat-raised-button>
                                Corrigeer Lengtemarkering
                            </button>
                        }
                        <mat-menu #menu="matMenu">
                            <button (click)="correctLengthmark()" mat-menu-item>Handmatige corrigeren</button>
                            <button (click)="redoBingSnappedPoints()" mat-menu-item>Berekening met gereden route</button>
                            <button (click)="redoBingSnappedPoints(false, false)" mat-menu-item>Berekening <b>zonder</b> gereden route</button>
                            <button (click)="redoBingSnappedPoints(true)" mat-menu-item>Berekening als fiets/wandel pad</button>
                            <button (click)="redoBingSnappedPoints(true, false)" mat-menu-item>Berekening als fiets/wandel pad <b>zonder</b> gereden route</button>
                        </mat-menu>
                    </div>
                }
                @if (AuthorisationService.hasFeature('pushpinSave')) {
                    <div class="controls-bottom">
                        @if (!isCordova) {
                            <label matTooltip="Upload afbeeldingen" matTooltipPosition="before">
                                <input (change)="uploadFile($event)" hidden multiple type="file">
                                <div class="fab big">
                                    @if (uploading()) {
                                        <i class="fas fa-circle-notch fa-spin"></i>
                                    } @else {
                                        <i class="fas fa-camera"></i>
                                    }
                                </div>
                            </label>
                        }
                        @if (activePushpinPart() && isCordova) {
                            <div
                                (click)="takePicture()"
                                class="fab big"
                                id="btn-AddImage"
                                matTooltip="Camera"
                                matTooltipPosition="before">
                                <i class="fas fa-camera"></i>
                            </div>
                        }
                        @if (showSave()) {
                            <div
                                (click)="save()"
                                [class.disabled]="saving() || activePushpinPart()?.inspection?.lock"
                                class="fab big primary"
                                id="btn-Save"
                                matTooltip="Opslaan"
                                matTooltipPosition="before">
                                @if (saving()) {
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                } @else {
                                    <i class="fas fa-save"></i>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
<div class="version-info">{{cordovaVersion()}}</div>
@if (loading()) {
    <app-loading text='Momentje, de punaise wordt geladen...'></app-loading>
}
